import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Button } from '../components/ui/button';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';

const PostProductionPage = () => {
  const { t } = useLanguage();

  const services = [
    {
      titleKey: 'animationsVFXTitle',
      descKey: 'animationsVFXDesc',
      image: 'https://customer-assets.emergentagent.com/job_2c966088-8797-43ff-a34e-a4775ed9024e/artifacts/j2wrj0ik_animatie.png'
    },
    {
      titleKey: 'colorGradingTitle',
      descKey: 'colorGradingDesc',
      image: 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=600&q=80'
    },
    {
      titleKey: 'socialVidzz',
      descKey: 'socialVidzzDesc',
      image: 'https://customer-assets.emergentagent.com/job_2c966088-8797-43ff-a34e-a4775ed9024e/artifacts/kyt41j4q_socialvidzz.jpg'
    },
    {
      titleKey: 'videoTestimonials',
      descKey: 'videoTestimonialsDesc',
      image: 'https://customer-assets.emergentagent.com/job_2c966088-8797-43ff-a34e-a4775ed9024e/artifacts/rgjo8rq4_Testimonials.jpg'
    },
    {
      titleKey: 'extraLanguageSupport',
      descKey: 'extraLanguageSupportDesc',
      image: 'https://customer-assets.emergentagent.com/job_2c966088-8797-43ff-a34e-a4775ed9024e/artifacts/t49fdc9e_language.webp'
    },
    {
      titleKey: 'audioProductionTitle',
      descKey: 'audioProductionDesc',
      image: 'https://customer-assets.emergentagent.com/job_2c966088-8797-43ff-a34e-a4775ed9024e/artifacts/x2hcam6a_audio.jpg'
    }
  ];

  const processSteps = [
    { titleKey: 'importOrganize', descKey: 'importOrganizeDesc', icon: '📥' },
    { titleKey: 'roughCut', descKey: 'roughCutDesc', icon: '✂️' },
    { titleKey: 'fineEditing', descKey: 'fineEditingDesc', icon: '🎬' },
    { titleKey: 'colorSound', descKey: 'colorSoundDesc', icon: '🎨' }
  ];

  return (
    <div className="min-h-screen">
      <SEO 
        title="Post Production"
        description="Professional post-production services including animations, visual effects, color grading, audio production, and video editing in Suriname."
        keywords="post-production, video editing, color grading, visual effects, animations, audio production, Suriname"
        canonical="/post-production"
      />
      <Header />
      
      {/* Page Content */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <h1 className="font-montserrat-bold text-3xl md:text-4xl lg:text-5xl text-[#0b004c] mb-6">
              {t('postProductionTitle')}
            </h1>
            <p className="font-montserrat text-base md:text-lg text-[#6a6a6a] mb-4">
              {t('postProductionDesc1')}
            </p>
            <p className="font-montserrat text-base md:text-lg text-[#6a6a6a]">
              {t('postProductionDesc2')}
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {services.map((service, index) => (
              <div key={index} className="bg-gray-50 rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300">
                <div className="aspect-video overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={t(service.titleKey)}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-montserrat-bold text-xl text-[#0b004c] mb-3">
                    {t(service.titleKey)}
                  </h3>
                  <p className="font-montserrat text-[#6a6a6a]">
                    {t(service.descKey)}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Process Section */}
          <div className="bg-[#0b004c] rounded-xl p-8 md:p-12">
            <h2 className="font-montserrat-bold text-2xl md:text-3xl text-white text-center mb-12">
              {t('postProductionProcess')}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              {processSteps.map((step, index) => (
                <div key={index} className="text-center">
                  <div className="text-4xl mb-4">{step.icon}</div>
                  <h3 className="font-montserrat-bold text-white text-lg mb-2">{t(step.titleKey)}</h3>
                  <p className="font-montserrat text-white/70 text-sm">{t(step.descKey)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-100">
        <div className="container mx-auto px-4 text-center">
          <h2 className="font-montserrat-bold text-2xl md:text-3xl text-[#0b004c] mb-4">
            {t('needPostProduction')}
          </h2>
          <p className="font-montserrat text-[#6a6a6a] mb-8 max-w-2xl mx-auto">
            {t('postProductionCTADesc')}
          </p>
          <Button className="bg-[#0b004c] hover:bg-[#1a0066] text-white px-8 py-3 font-montserrat-bold">
            {t('startYourProject')}
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PostProductionPage;
